module.exports = __webpack_public_path__ + "static/media/stress-relief.6729ad60.png";